import { render } from "./ZodiacSelector.vue?vue&type=template&id=1d15b87e&scoped=true"
import script from "./ZodiacSelector.vue?vue&type=script&lang=js"
export * from "./ZodiacSelector.vue?vue&type=script&lang=js"

import "./ZodiacSelector.vue?vue&type=style&index=0&id=1d15b87e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d15b87e"]])

export default __exports__